import * as angular from 'angular';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import template from './moldHistory.tpl.html';

export interface MoldHistoryData {
  mold: apsViewModels.ToolActivity;
}

export function openMoldHistory(
  data: MoldHistoryData,
  $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'MoldHistoryCtrl as historyCtrl',
    windowClass: 'small-dialog',
    resolve: {
      data: function () {
        return data;
      }
    }
  }).result;
}

export default angular.module('aps.controller.moldHistory', [])
  .controller('MoldHistoryCtrl', moldHistoryCtrl)
  .name;

function moldHistoryCtrl($modalInstance: mm.foundation.modalInstance,
  data: MoldHistoryData) {
  let vm = this;
  vm.mold = data.mold;

  vm.close = function () {
    $modalInstance.close();
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/toolHistory/moldHistory.controller.ts